import React, {useState} from 'react';
import {Modal, Button, Form} from 'react-bootstrap';

interface AddMemberModalProps {
  show: boolean;
  onHide: () => void;
  onAdd: (email: string) => void;
  mailingListAddress?: string;
}

const AddMemberModal: React.FC<AddMemberModalProps> = ({
  show,
  onHide,
  onAdd,
  mailingListAddress,
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email: string): boolean => {
    // Validation complète de l'adresse email
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("L'adresse email est obligatoire");
      return;
    }

    if (!validateEmail(email)) {
      setError("Format d'adresse email invalide");
      return;
    }

    onAdd(email);
    handleClose();
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-solid fa-plus me-2 text-primary"></i>
          Ajouter un membre
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {mailingListAddress && (
            <div className="alert alert-info mb-3">
              <i className="fa-solid fa-info-circle me-2"></i>
              Ajout à la liste : <strong>{mailingListAddress}</strong>
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Adresse email du membre <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="exemple@domaine.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              isInvalid={!!error}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
            <Form.Text className="text-muted">
              Entrez l'adresse email complète du membre
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="primary" type="submit">
            <i className="fa-solid fa-plus me-2"></i>
            Ajouter
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddMemberModal;